import { render } from "./ConfirmModal.vue?vue&type=template&id=3a65bda4&scoped=true&ts=true"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts"

import "./ConfirmModal.vue?vue&type=style&index=0&id=3a65bda4&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a65bda4"]])

export default __exports__